import { getApiCall } from "./tokenService";
import { CodeTitle } from "../models/common/codeTitle";

export const getTimeZones = (signal: AbortSignal): Promise<CodeTitle[]> => {
    return getApiCall("api/timezone", null, signal);
};
